(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hokema-ad-landing"] && !Shopify.designMode) return;
  try {
    
  function initializeHokemaLandings(root) {
    root.querySelectorAll('.hkl').forEach(section => {
      if (section.dataset.hklReady) return;
      section.dataset.hklReady = 'true';
      section.querySelectorAll('audio').forEach(audio => audio.addEventListener('play', () => {
        section.querySelectorAll('audio').forEach(other => { if (other !== audio) other.pause(); });
      }));
      const filters = section.querySelector('.hkl__filters');
      if (!filters) return;
      filters.hidden = false;
      filters.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
        filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        section.querySelectorAll('[data-hkl-card]').forEach(card => { card.hidden = button.dataset.hklFilter !== 'all' && card.dataset.hklCard !== button.dataset.hklFilter; });
      }));
    });
  }
  initializeHokemaLandings(document);
  document.addEventListener('shopify:section:load', event => initializeHokemaLandings(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hokema-sansula-basic"] && !Shopify.designMode) return;
  try {
    
  function initializeSansulaAlternative(scope) {
    scope.querySelectorAll('.hkl2').forEach(root => {
      if (root.dataset.hkl2Ready) return;
      root.dataset.hkl2Ready = 'true';
      root.querySelectorAll('[data-hkl2-variant]').forEach(select => {
        select.addEventListener('change', () => {
          const purchase = select.closest('.hkl2__purchase');
          const option = select.selectedOptions[0];
          if (!option) return;
          purchase.querySelector('[data-hkl2-price]').textContent = option.dataset.price;
          const shipping = purchase.querySelector('[data-hkl2-free-shipping]');
          if (shipping) shipping.hidden = option.dataset.freeShipping !== 'true';
        });
      });
      const dialog = root.querySelector('dialog');
      if (dialog) {
        const link = root.querySelector('[data-hkl2-listen]');
        const player = dialog.querySelector('[data-hkl2-player]');
        link.addEventListener('click', event => {
          if (typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          player.replaceChildren(dialog.querySelector('template').content.cloneNode(true));
          dialog.showModal();
        });
        dialog.querySelector('[data-hkl2-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => { player.replaceChildren(); link.focus(); });
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      }
      let delayElapsed = false;
      const models = root.querySelector('.hkl2__models');
      const updateTeaser = () => {
        if (!root.isConnected) { window.removeEventListener('scroll', updateTeaser); return; }
        root.toggleAttribute('data-offer-ready', delayElapsed && models.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', updateTeaser, { passive: true });
      window.setTimeout(() => { delayElapsed = true; updateTeaser(); }, 45000);
      updateTeaser();
    });
  }
  initializeSansulaAlternative(document);
  document.addEventListener('shopify:section:load', event => initializeSansulaAlternative(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hokema-sansula-l2"] && !Shopify.designMode) return;
  try {
    
  function initializeSansulaAlternative(scope) {
    scope.querySelectorAll('.hkl2').forEach(root => {
      if (root.dataset.hkl2Ready) return;
      root.dataset.hkl2Ready = 'true';
      root.querySelectorAll('[data-hkl2-variant]').forEach(select => {
        select.addEventListener('change', () => {
          const purchase = select.closest('.hkl2__purchase');
          const option = select.selectedOptions[0];
          if (!option) return;
          purchase.querySelector('[data-hkl2-price]').textContent = option.dataset.price;
          const shipping = purchase.querySelector('[data-hkl2-free-shipping]');
          if (shipping) shipping.hidden = option.dataset.freeShipping !== 'true';
        });
      });
      const dialog = root.querySelector('dialog');
      if (dialog) {
        const link = root.querySelector('[data-hkl2-listen]');
        const player = dialog.querySelector('[data-hkl2-player]');
        link.addEventListener('click', event => {
          if (typeof dialog.showModal !== 'function') return;
          event.preventDefault();
          player.replaceChildren(dialog.querySelector('template').content.cloneNode(true));
          dialog.showModal();
        });
        dialog.querySelector('[data-hkl2-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('close', () => { player.replaceChildren(); link.focus(); });
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      }
      let delayElapsed = false;
      const models = root.querySelector('.hkl2__models');
      const updateTeaser = () => {
        if (!root.isConnected) { window.removeEventListener('scroll', updateTeaser); return; }
        root.toggleAttribute('data-offer-ready', delayElapsed && models.getBoundingClientRect().bottom < 0);
      };
      window.addEventListener('scroll', updateTeaser, { passive: true });
      window.setTimeout(() => { delayElapsed = true; updateTeaser(); }, 45000);
      updateTeaser();
    });
  }
  initializeSansulaAlternative(document);
  document.addEventListener('shopify:section:load', event => initializeSansulaAlternative(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hokema-sansula-landing"] && !Shopify.designMode) return;
  try {
    
  function initializeSansulaLanding(root) {
    root.querySelectorAll('[data-hks-variant]').forEach(select => {
      if (select.dataset.hksReady) return;
      select.dataset.hksReady = 'true';
      select.addEventListener('change', () => {
        const price = select.closest('.hks__purchase').querySelector('[data-hks-price]');
        if (price && select.selectedOptions[0]) price.textContent = select.selectedOptions[0].dataset.price;
      });
    });
  }
  initializeSansulaLanding(document);
  document.addEventListener('shopify:section:load', event => initializeSansulaLanding(event.target));

  } catch(e) { console.error(e); }
})();
})();
